module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-beijing.20c200e2.webm";